import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, PLATFORM_ID, QueryList, Renderer2, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { SeoService } from '../../../app/core/services/seo.service';
import { CommonService } from '../../../app/core/services/common.service';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
declare var $:any;

@Component({
  selector: 'app-digital-marketing',
  templateUrl: './digital-marketing.component.html',
  styleUrls: ['./digital-marketing.component.scss'],
  providers: [MessageService]

})
export class DigitalMarketingComponent implements OnInit {

constructor(private router : Router,private seo :SeoService, private translate : TranslateService,private titleService : Title,
   private renderer: Renderer2,
     @Inject(PLATFORM_ID) private platformId: Object, private sanitizer: DomSanitizer, private formBuilder: FormBuilder,
     public commonService : CommonService, private el: ElementRef,private cdr: ChangeDetectorRef,private messageService: MessageService) { }
    signUrl = environment.WEB_URL;
   emailValidations: FormGroup;
    plansLoader = false;
    subscriptionPlans = [];
    selectedPlanView = 0;
    domainError = false;
    faqAccordion = [
      {
        "question": "How does Amy.pro ensure the quality of marketing professionals?",
        "ans": "Amy.pro implements a rigorous vetting process to ensure the quality of professionals on the platform. Every specialist undergoes a comprehensive review that includes verifying their expertise, work experience, and client feedback. Additionally, Amy.pro provides ratings and reviews to help you make informed decisions."
      },
      {
        "question": "Can I scale my marketing services as my business grows?",
        "ans": "Yes, Amy.pro offers scalable solutions tailored to your business needs. You can start with a single specialist or small-scale service and expand by hiring additional professionals or outsourcing to agencies as your requirements grow. The platform allows for flexibility to match your business's evolving demands."
      },
      {
        "question": "What types of agencies can I find for outsourcing?",
        "ans": "Amy.pro connects you with a diverse range of specialized agencies to meet your marketing needs. You can work with SEO and SEM agencies that focus on improving your website's visibility through search engine optimization and pay-per-click campaigns. Content marketing and strategy agencies help craft high-quality, engaging content to enhance your brand’s authority and drive organic traffic. Social media management agencies specialize in creating and executing impactful campaigns on platforms like Instagram, LinkedIn, and Facebook to boost engagement and build a strong online presence. You can also collaborate with email marketing agencies that create personalized campaigns to nurture leads and improve customer retention. For comprehensive support, Amy.pro offers access to full-service digital marketing firms that manage end-to-end campaigns, ensuring seamless execution of all your marketing efforts."
      },
      {
        "question": "How quickly can I onboard a specialist or agency?",
        "ans": "Onboarding is fast and seamless with Amy.pro. Once you post your requirements, specialists or agencies can be matched within 24-48 hours. After selection, onboarding and project initiation can begin immediately, ensuring minimal downtime for your marketing needs."
      }
    ]

  ngOnInit(): void {
    this.getPlansDetails();
      this.emailValidations = this.formBuilder.group({
        emailId: [
          "",
          [
            Validators.required,
            Validators.email,
            Validators.pattern(
              "[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
            ),
          ],
        ],
      });
    }

    ngAfterViewInit(): void {
      // Store the heights of all content wrappers
      this.contentHeights = this.contentWrappers.map(
       (wrapper) => wrapper.nativeElement.scrollHeight
     );
   }
  
    get f(): { [key: string]: AbstractControl } {
      return this.emailValidations.controls;
    }
  
    validateEmailDomain(email) {
      this.commonService.validateEmailDomains(email).subscribe((res: any) => {
        if (res) {
        } else {
          this.showError("Enter valid email address");
        }
      });
    }
  
    showError(message) {}
  
  
    onSubmit() {
      // Mark all controls as touched to trigger validation errors
      this.markFormGroupTouched(this.emailValidations);
      if (this.emailValidations.valid) {
        this.commonService.validateEmailDomains($('#workmail').val()).subscribe((res: any) => {
          this.domainError = false;
          if (res) {
            const newTab = this.renderer.createElement('a');
            this.renderer.setAttribute(newTab, 'href', this.signUrl + 'get-started/u/setup-profile?workmail=' + $('#workmail').val());
            this.renderer.setAttribute(newTab, 'target', '_blank');
            this.renderer.appendChild(document.body, newTab);
            newTab.click();
            this.renderer.removeChild(document.body, newTab);
          } else {
            this.domainError = true;
            this.messageService.add({
              severity: 'error',
              detail: 'Enter a valid workmail.',
            });
            return;
          }  
        });
      } else {
        if (this.emailValidations.invalid) {
          if (this.emailValidations.get('emailId')?.hasError('required')) {
            this.messageService.add({
              severity: 'error',
              detail: 'Email is required.',
            });
          } else if (
            this.emailValidations.get('emailId')?.hasError('email') ||
            this.emailValidations.get('emailId')?.hasError('pattern')
          ) {
            this.messageService.add({
              severity: 'error',
              
              detail: 'Please enter a valid email.',
            });
          }
          return;
        }
      }  
    }
  
    
    // Helper method to mark all controls in a form group as touched
    private markFormGroupTouched(formGroup: FormGroup) {
      Object.values(formGroup.controls).forEach((control) => {
        control.markAsTouched();
  
        if (control instanceof FormGroup) {
          this.markFormGroupTouched(control);
        }
      });
    }


  public getPlansDetails(){

    this.plansLoader = true;
    this.commonService.getAllNewPlans({type: [0,1,2,3,4,5,6]}).subscribe((res : any) => {
      const planDetails = res.message;
      let allPlans = [...planDetails[0], ...planDetails[5]];
      allPlans.pop();  // Removes the last element from the array
      this.subscriptionPlans = allPlans;      
      this.plansLoader = false;
    }, err=> {
      this.plansLoader = false;
    });
  }

  getAppNameByKey(key: string): string {
    const nameMap = {
      amy: 'Amy',
      amyCms: 'Amy CMS',
      connect: 'Amy Connect',
      enterpriseAi : 'Enterprise AI (Ask Amy)'
    };

    return nameMap[key] || '';
  }
  featuresToDisplay(plan) {
    return this.selectedPlanView === 0 ? plan.features : (plan.features_yearly ? plan.features_yearly : plan.features);
  }

  expandedIndex = 0;
  togglePanel(index: number): void {
    this.expandedIndex = this.expandedIndex === index ? null : index;
}
      @ViewChildren('contentWrapper') contentWrappers!: QueryList<ElementRef>;
      contentHeights: number[] = [];  

}
